"use client";

import { FC, useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

import { useQueryParams } from "apps/website/hooks/useQueryParams";

const shouldChainParams = (link: string | undefined) => link && ((link.startsWith("/") && !link.startsWith("/manage-plan")) || link.includes("katkin.com"));

interface IQuerySetterProps {
  href: string;
  onUpdateHref(href: string): void;
}

export const QuerySetter: FC<IQuerySetterProps> = ({ href, onUpdateHref }) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { chainQueryParamsToUrl } = useQueryParams();

  useEffect(() => {
    const hrefWithQuery = shouldChainParams(href) ? chainQueryParamsToUrl(href) : href;
    onUpdateHref(hrefWithQuery);
  }, [ searchParams, pathname ]);

  return (<></>);
};
